export enum Type {
  VIDEO_UPLOAD_REQUEST = 'app/video-upload/VIDEO_UPLOAD_REQUEST',
  VIDEO_UPLOAD_SUCCESS = 'app/video-upload/VIDEO_UPLOAD_SUCCESS',
  VIDEO_UPLOAD_FAILURE = 'app/video-upload/VIDEO_UPLOAD_FAILURE',
  VIDEO_UPLOAD_PROGRESS = 'app/video-upload/VIDEO_UPLOAD_PROGRESS',
  MULTIPART_UPLOAD_INIT_SUCCESS = 'app/video-upload/MULTIPART_UPLOAD_INIT_SUCCESS',
}
